export default {
  green: '#7cc653',
  darkgreen: '#559b2e',
  blue: '#085aa6',
  lightBlue: '#cfdbe6',
  red: '#C33149',
  grey: '#c5c5c5',
  darkgrey: '#6A757F',
}